import type { ContextMenuItemDefinition } from '../components/context_menu/types';

/**
 * Automatically adds separators between arrays of context menu item definitions.
 *
 * @example
 * const groupA = [item1]
 * const custom = [custom1]
 * const tail = [tail]
 *
 * separateMenuGroups([groupA, custom, tail]) => [item1, Separator, custom1, Separator, tail]
 *
 * @param itemGroups Array of arrays of ContextMenuItemDefinition.
 * @param contextItemsLength
 * @returns Flattened Array of item with separator objects between each element of arrays in itemGroups parameter.
 */
const separateMenuGroups = (
  itemGroups: ContextMenuItemDefinition[][],
  contextItemsLength?: number,
): ContextMenuItemDefinition[] => {
  const multipleContextItems = contextItemsLength
    ? contextItemsLength > 1
    : false;

  const filteredItems = itemGroups.filter(
    (group) =>
      group.filter(({ multiple = false }) =>
        multipleContextItems ? multiple : true,
      ).length > 0,
  );

  return filteredItems.flatMap((items, index) =>
    index !== 0 ? [{ separator: true }, ...items] : items,
  );
};

export default separateMenuGroups;
